import { Box } from '@apia/theme';
import { Icon } from '@apia/icons';

export interface ICheckbox {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => unknown;
}

export const Checkbox = (props: ICheckbox) => {
  return (
    <Box
      className="accordion__item__button__check"
      onClick={(ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        if (!props.disabled) props.onChange?.(!props.checked);
      }}
    >
      {props.checked && <Icon title="" name="Check" />}
    </Box>
  );
};
